import { render, staticRenderFns } from "./rewards.vue?vue&type=template&id=e63390fc&scoped=true&"
import script from "./rewards.vue?vue&type=script&lang=js&"
export * from "./rewards.vue?vue&type=script&lang=js&"
import style0 from "./rewards.vue?vue&type=style&index=0&id=e63390fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63390fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
